import { useRef } from 'react';
import { useTranslation } from 'react-i18next';

import { useSessionKeepAlive } from '@/hooks/use-session-keep-alive';
import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';

export const SessionIdleGuard = () => {
  const { t } = useTranslation(['auth', 'common']);
  const { warningOpen, staySignedIn, signOutNow } = useSessionKeepAlive();
  const signingOut = useRef(false);

  return (
    <Dialog
      open={warningOpen}
      onOpenChange={(open) => {
        if (open) {
          signingOut.current = false;
          return;
        }
        if (!signingOut.current) staySignedIn();
      }}
    >
      <DialogContent size="sm" hideCloseButton closeLabel={t('action.close', { ns: 'common' })}>
        <DialogHeader>
          <DialogTitle>{t('idleWarning.title')}</DialogTitle>
          <DialogDescription>{t('idleWarning.description')}</DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button
            type="button"
            variant="outline"
            onClick={() => {
              signingOut.current = true;
              signOutNow();
            }}
          >
            {t('idleWarning.signOut')}
          </Button>
          <Button type="button" onClick={staySignedIn}>
            {t('idleWarning.staySignedIn')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
